import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import './Wishlist.css';
import { useShop } from '../context/ShopContext';
import { formatPrice } from '../data/products';

function Wishlist() {
  const { wishlistItems, toggleWishlist, addToCart } = useShop();
  const [filter, setFilter] = useState('all');

  const defaultOptions = (item) => ({
    size: item.sizeOptions?.[0] || 'One Size',
    color: item.colorOptions?.[0] || 'Default',
  });

  const filteredItems = useMemo(() => {
    if (filter === 'all') return wishlistItems;
    return wishlistItems.filter(
      (item) => (item.category || '').toLowerCase() === filter
    );
  }, [wishlistItems, filter]);

  if (wishlistItems.length === 0) {
    return (
      <div className="wishlist-page">
        <div className="wishlist-header">
          <h1>Wishlist</h1>
          <p>Save items you love and add them to cart when you are ready.</p>
          <div className="wishlist-actions">
            <Link className="primary-btn" to="/womens">
              Browse Women&apos;s
            </Link>
            <Link className="ghost-btn" to="/mens">
              Browse Men&apos;s
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="wishlist-page">
      <div className="wishlist-header">
        <h1>Wishlist</h1>
        <p>Items you have saved from The Shapes United catalogue.</p>
        <div className="wishlist-filters">
          {['all', 'mens', 'womens', 'kids'].map((key) => (
            <button
              key={key}
              className={`filter-chip ${filter === key ? 'active' : ''}`}
              onClick={() => setFilter(key)}
            >
              {key === 'all'
                ? 'All'
                : key === 'mens'
                ? "Men's"
                : key === 'womens'
                ? "Women's"
                : 'Kids'}
            </button>
          ))}
          <span className="filter-count">
            {filteredItems.length} item{filteredItems.length !== 1 ? 's' : ''}
          </span>
        </div>
      </div>

      {filteredItems.length === 0 ? (
        <div className="wishlist-empty">
          <p>No items in this category yet.</p>
          <div className="wishlist-actions">
            <Link className="primary-btn" to="/mens">
              Shop Men&apos;s
            </Link>
            <Link className="ghost-btn" to="/womens">
              Shop Women&apos;s
            </Link>
            <Link className="ghost-btn" to="/kids">
              Shop Kids
            </Link>
          </div>
        </div>
      ) : (
        <div className="wishlist-grid">
          {filteredItems.map((item) => (
            <div className="wishlist-card" key={item.id}>
              <div className="wishlist-thumb">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="wishlist-info">
                <p className="wishlist-category">
                  {item.categoryLabel || item.category}
                </p>
                <h3>{item.title}</h3>
                {item.brand && <p className="wishlist-brand">{item.brand}</p>}
                <p className="wishlist-price">
                  {formatPrice(item.price, item.currency)}
                </p>
                <div className="wishlist-buttons">
                  <button
                    className="primary-btn"
                    onClick={() => addToCart(item.id, defaultOptions(item))}
                  >
                    Add to Cart
                  </button>
                  <button
                    className="ghost-btn"
                    onClick={() => toggleWishlist(item.id)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Wishlist;
